import { render, staticRenderFns } from "./OSgovShipUpdate.vue?vue&type=template&id=62500227"
import script from "./OSgovShipUpdate.vue?vue&type=script&lang=js"
export * from "./OSgovShipUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports